import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const PurchaseUpgrade = lazyWithPreload(
  () => import('./PurchaseUpgrade'),
)
